module.exports = __webpack_public_path__ + "static/media/github.0a3a0978.svg";